import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'makeBoldPartOfText',
    standalone: false
})
export class MakeBoldPartOfTextPipe implements PipeTransform {

  transform(text: string, textPart: string): string {
    if (!textPart) {
      return text;
    }

    return text?.replace(RegExp('('+textPart+')', 'gi'), '<span class="bg-brand text-white">$1</span>');
  }
}
